import { FC } from 'react';

import styles from './style.module.scss';

const NotFound: FC = () => {
  return (
    <div className={styles.container}>
      <h2>Page Not Found!</h2>
    </div>
  );
};

export default NotFound;
